import { useEffect } from "react";

type ScrollPosition = {
    x: number;
    y: number;
};

const useScrollListener = (
    elementId: string,
    callback: (scrollPosition: ScrollPosition) => void
) => {
    useEffect(() => {
        const element = document.getElementById(elementId);

        if (!element) {
            // console.warn(`Element with id "${elementId}" not found`);
            return;
        }

        const handleScroll = (event: Event) => {
            const target = event.target as HTMLElement;
            callback({
                x: target.scrollLeft,
                y: target.scrollTop
            });
        };

        element.addEventListener('scroll', handleScroll);

        return () => {
            element.removeEventListener('scroll', handleScroll);
        };
    }, [elementId, callback]);
};

export default useScrollListener;